"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockVVSRouterFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "MULTIPLIER_BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fallbackMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "getAmountsIn",
        outputs: [
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "getAmountsOut",
        outputs: [
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_fallbackMultiplier",
                type: "uint256",
            },
        ],
        name: "setFallbackMultiplier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenOut",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        name: "setMultiplier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapETHForExactTokens",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountInMax",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapTokensForExactETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountInMax",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapTokensForExactTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenOutMultipliers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class MockVVSRouterFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockVVSRouterFactory = MockVVSRouterFactory;
MockVVSRouterFactory.bytecode = _bytecode;
MockVVSRouterFactory.abi = _abi;
//# sourceMappingURL=MockVVSRouterFactory.js.map